export default __webpack_public_path__ + "static/media/Artist | @briggs.a43f7568.pdf";